export class DepthUtil {
    static ButtonBGDepth = 1;
    static TextDepth = 2;
}